import { getCookie } from "./utils";

export const getSipContacts = async () => {
  const token = getCookie("token");

  if (!token) {
    window.location.href = `/auth/google?redirectURL=${window.location.pathname + window.location.search}`;
  }

  let response;
  try {
    response = await fetch("/api/sip/contacts", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error("Network error fetching user:", error);
  }

  if (response.status === 401) {
    document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  }

  if (!response.ok) {
    console.error(`Failed to fetch sip contacts: ${response.statusText}`);
  }

  // All good, return user data.
  return await response.json();
}

export const getDevices = async (userId) => {
  const token = getCookie("token");

  if (!token) {
    window.location.href = `/auth/google?redirectURL=${window.location.pathname + window.location.search}`;
  }

  let response;
  try {
    response = await fetch(`/api/sip/devices/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error(error);
    window.location.href = `/auth/google?redirectURL=${window.location.pathname + window.location.search}`;
  }

  return response?.json();
}

export const createDeviceLink = async (userId) => {
  const token = getCookie("token");

  if (!token) {
    window.location.href = `/auth/google?redirectURL=${window.location.pathname + window.location.search}`;
  }

  let response;
  try {
    response = await fetch(`/api/sip/devices/create/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error("Network error fetching user:", error);
    window.location.href = `/auth/google?redirectURL=${window.location.pathname + window.location.search}`;
  }

  return response?.json();
}

export const updateDeviceConfig = async (linkId, configuration) => {
  const token = getCookie("token");

  let response;
  try {
    response = await fetch(`/api/sip/devices/configuration/${linkId}`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(configuration)
    });
  } catch (error) {
    console.error(error);
  }
}

export const unlinkDevice = async (id) => {
  const token = getCookie("token");

  if (!token) {
    window.location.href = `/auth/google?redirectURL=${window.location.pathname + window.location.search}`;
  }

  let response;
  try {
    response = await fetch(`/api/sip/devices/unlink/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error("Network error fetching user:", error);
    window.location.href = `/auth/google?redirectURL=${window.location.pathname + window.location.search}`;
  }

  return response?.json();
}

export const deleteDevice = async (id) => {
  const token = getCookie("token");

  if (!token) {
    window.location.href = `/auth/google?redirectURL=${window.location.pathname + window.location.search}`;
  }

  let response;
  try {
    response = await fetch(`/api/sip/devices/${id}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error("Network error fetching user:", error);
    window.location.href = `/auth/google?redirectURL=${window.location.pathname + window.location.search}`;
  }

  return response?.json();
}
